import { ThunderboltOutlined } from "@ant-design/icons";
import { Row, Typography } from "antd";
import { clsx } from "clsx";

import { RVIcon, RVIconVariantOptions, RVIconSizeOptions } from "@regal-voice/ui";
import { BlockContainer } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContainer/BlockContainer";
import { BlockContent } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockContent/BlockContent";
import { BlockTitle } from "Components/elements/RVFlow/Shared/FlowNodeBlocks/BlockTitle/BlockTitle";
import {
    getJourneyNodeIcon,
    getJourneyNodeTypeConfig,
} from "Components/elements/RVFlow/Shared/JourneyNodePresentation";
import { UpdateContactForm } from "Pages/orchestration/Pages/journeys/JourneyEditPage/Components/JourneyBuilder/Components/JourneyActionsPanel/NodeEditorPanel/Components/UpdateContactFormItems/constants";
import { NodeType } from "Types/Journey";

import { useJourneyBlockData } from "../Shared/Hooks/useJourneyBlockData/useJourneyBlockData";

import type { SharedBlockProps } from "Components/elements/RVFlow/RVFlowTypes";

import styles from "./UpdateContactBlock.module.scss";

const BLOCK_TITLE = "Action";
const NODE_TITLE = "Update Contact";
const NODE_PROMPT = "Configure Update Contact";

const BLOCK_VARIANT = getJourneyNodeTypeConfig(NodeType.UpdateContact).variant;
const BLOCK_ICON = getJourneyNodeIcon(NodeType.UpdateContact);

export function UpdateContactBlock({ data, variant, isDisabled }: SharedBlockProps): JSX.Element {
    const {
        [UpdateContactForm.updateContactName]: updateContactName,
        [UpdateContactForm.eventName]: eventName,
        [UpdateContactForm.profileListName]: profileAttributesList,
    } = data || {};

    const isNodeConfigured = !!eventName || !!profileAttributesList;

    const { fallBackTitle, isBlock, isActive, nodeName } = useJourneyBlockData({
        variant,
        isNodeConfigured,
        preferedNodeName: updateContactName || NODE_TITLE,
        blockTitle: BLOCK_TITLE,
        nodeTitle: NODE_TITLE,
        nodePropmpt: NODE_PROMPT,
    });

    const attrsText = Object.keys(profileAttributesList || {}).length
        ? `Contact Attributes (${Object.keys(profileAttributesList).length})`
        : "";

    return (
        <BlockContainer isDisabled={isDisabled} variant={BLOCK_VARIANT} icon={BLOCK_ICON}>
            <BlockTitle isDisabled={isDisabled} nodeData={data} fallBackDisplay={fallBackTitle}></BlockTitle>

            <BlockContent isActive={isActive}>
                <Typography.Text
                    className={clsx({
                        [styles.isDisabledName]: isDisabled,
                    })}
                >
                    {nodeName}
                </Typography.Text>

                {!isBlock && eventName && (
                    <BlockContent isActive={isActive}>
                        <Row className={styles.subInfoContainer}>
                            <ThunderboltOutlined />
                            <Typography.Text ellipsis className={styles.subTitle}>
                                {eventName}
                            </Typography.Text>
                        </Row>
                    </BlockContent>
                )}

                {!isBlock && attrsText && (
                    <BlockContent isActive={isActive}>
                        <Row className={styles.subInfoContainer}>
                            <RVIcon
                                className={styles.iconNudge}
                                icon="tasks"
                                variant={RVIconVariantOptions.DEFAULT}
                                size={RVIconSizeOptions.XSMALL}
                            />
                            <Typography.Text ellipsis className={styles.subTitle}>
                                {attrsText}
                            </Typography.Text>
                        </Row>
                    </BlockContent>
                )}
            </BlockContent>
        </BlockContainer>
    );
}
